/**
 * FieldEditor — admin config for one custom form field: type, label, help text,
 * options (for choice types), required flag, and reorder/remove controls.
 */
import React from 'react';
import { FIELD_TYPES, fieldHasOptions } from '../fieldTypes';

export default function FieldEditor({ field, index, count, onChange, onRemove, onMove }) {
  const patch = (p) => onChange({ ...field, ...p });
  const hasOptions = fieldHasOptions(field.type);

  const changeType = (type) => {
    const next = { ...field, type };
    if (fieldHasOptions(type) && !next.options) next.options = ['Option 1', 'Option 2'];
    onChange(next);
  };

  const setOption = (i, val) => {
    const options = [...(field.options || [])];
    options[i] = val;
    patch({ options });
  };
  const addOption = () =>
    patch({ options: [...(field.options || []), `Option ${(field.options || []).length + 1}`] });
  const removeOption = (i) => patch({ options: (field.options || []).filter((_, idx) => idx !== i) });

  const isHeading = field.type === 'heading';

  return (
    <div className="ev-fieldcard">
      <div className="ev-fieldcard__top">
        <select className="ev-input ev-input--sm" value={field.type} onChange={(e) => changeType(e.target.value)}>
          {FIELD_TYPES.map((ft) => (
            <option key={ft.type} value={ft.type}>{ft.icon} {ft.label}</option>
          ))}
        </select>
        <div className="ev-fieldcard__actions">
          <button className="ev-iconbtn" disabled={index === 0} onClick={() => onMove(-1)} title="Move up">↑</button>
          <button className="ev-iconbtn" disabled={index === count - 1} onClick={() => onMove(1)} title="Move down">↓</button>
          <button className="ev-iconbtn ev-iconbtn--danger" onClick={onRemove} title="Remove">✕</button>
        </div>
      </div>

      <input className="ev-input" placeholder={isHeading ? 'Section heading' : 'Question label'}
        value={field.label} onChange={(e) => patch({ label: e.target.value })} />

      <input className="ev-input" placeholder="Help text (optional)"
        value={field.helpText || ''} onChange={(e) => patch({ helpText: e.target.value })} />

      {hasOptions && (
        <div className="ev-options">
          {(field.options || []).map((o, i) => (
            <div key={i} className="ev-option-row">
              <input className="ev-input ev-input--sm" value={o} onChange={(e) => setOption(i, e.target.value)} />
              <button className="ev-iconbtn ev-iconbtn--danger" onClick={() => removeOption(i)}
                disabled={(field.options || []).length <= 1} title="Remove option">✕</button>
            </div>
          ))}
          <button className="ev-linkbtn" onClick={addOption}>+ Add option</button>
        </div>
      )}

      {!isHeading && (
        <label className="ev-check">
          <input type="checkbox" checked={!!field.required} onChange={(e) => patch({ required: e.target.checked })} />
          <span>Required</span>
        </label>
      )}
    </div>
  );
}
